// priority-items.component.ts
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Inject } from '@angular/core';
import { CardEntity } from 'src/app/models/entities/card.entity';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { Router } from '@angular/router';

import { CardModule } from '../card/card.module';
import { CardDueDatesComponent } from 'src/app/pages/dashboard/card-due-dates/card-due-dates.component';
import { MatIconModule } from '@angular/material/icon';
import { CardActionsComponent } from '../card-actions/card-actions.component';
import { TenantService } from 'src/app/services/tenant.service';

@Component({
    selector: 'app-priority-items-component',
    imports: [CommonModule, PipesModule, CardActionsComponent, MatIconModule, CardDueDatesComponent],
    templateUrl: './priority-items.component.html',
    styleUrls: ['./priority-items.component.scss']
})
export class PriorityItemsComponent {
  @Input() userCards: any[] = [];
  @Output() navCard = new EventEmitter<CardEntity>();

  constructor(
    public dialogRef: MatDialogRef<PriorityItemsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router,
    private tenantService: TenantService
  ) {
    if (data && data.priorities) {
      // Filter out invalid card objects that don't have the required 'name' property
      this.userCards = data.priorities.filter((card: any) => card && card.name);
    }
  }

  priorityLookup(index: number): string {
    return index === 1 ? 'High' : index === 2 ? 'Medium' : index === 3 ? 'Low' : 'Low';
  }

  navigateToCard(card: any): void {
    if (card && card.boardKey && card.key) {
      // Always carry the tenant in the query string — the auth guard honors ?t=
      // and switches tenants deterministically, so cross-tenant cards work and
      // the resulting address-bar URL is shareable.
      const currentTenantId = this.tenantService.getCurrentTenantId();
      const tenantId = card.tenantId || currentTenantId;
      if (card.tenantId && card.tenantId !== currentTenantId) {
        // Different tenant: full reload so all tenant-scoped services reinitialize
        window.location.href = `/board/${card.boardKey}/${card.key}?t=${card.tenantId}`;
      } else {
        this.router.navigate(['/board', card.boardKey, card.key], {
          queryParams: tenantId ? { t: tenantId } : undefined,
        });
      }
      this.close();
    }
  }

  close(): void {
    this.dialogRef.close();
  }
}